import { faHome, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Breadcrumb, Button, Col, Form, Row } from "@themesberg/react-bootstrap";
import Joi from "joi";
import React, { useState } from "react"
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { updateToastInfo } from "../../../actions/settings";
import { updateSpinnerState } from "../../../actions/spinner";
import { returnValidationErrorMessages } from "../../../utils/validation";
import { addNewCustomerCareManager } from "../../../parse-functions/customercare";

const addCustomerCareManagerSchema = Joi.object({
    managerName: Joi.string().required(),
    phoneNumber: Joi.string().length(10).required(),
    emailId: Joi.string().email({ tlds: { allow: false } }),
    username: Joi.string().required(),
    password: Joi.string().required(),
    repeatPassword: Joi.ref('password'),
})
const AddCustomerCareManager = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [formErrors, setFormErrors] = useState({});
    const [formData, setFormData] = useState({
        managerName: '',
        phoneNumber: '',
        emailId: '',
        username: '',
        password: '',
        repeatPassword: ''
    })

    const onFormInputChange = (fieldName, value) => {
        setFormData(oldFormData => ({
            ...oldFormData,
            [fieldName]: value
        }));
    };
    const handleFormSubmit = async () => {
        const { error: formErrors = {}, value: formValue } = addCustomerCareManagerSchema.validate(formData, {
            abortEarly: false
        });
        const {
            details = {}
        } = formErrors;
        if (details?.length > 0) {
            const validationErrorMessages = returnValidationErrorMessages(details);
            setFormErrors(validationErrorMessages);
        } else {
            dispatch(updateSpinnerState(true));
            try {
                await addNewCustomerCareManager(formValue);
                dispatch(updateToastInfo({
                    show: true,
                    type: "success",
                    title: t("CC Manager Added"),
                    message: t(`${formData.managerName} added successfully`)
                }))
            } catch (error) {
                // inside error
                const {
                    message,
                    code
                } = error;
                setFormErrors(message);
                dispatch(updateToastInfo({
                    show: true,
                    type: "danger",
                    title: t(`${formData.managerName} failed to add`),
                    message: error.error
                }))
            }
            dispatch(updateSpinnerState(false));
        }
    };
    return (
        <div className="mt-1">
            <div className="mb-4 d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-2">
                <div className="d-block mb-4 mb-md-0">
                    <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                        <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                        <Breadcrumb.Item>{t("Customer Care")}</Breadcrumb.Item>
                        <Breadcrumb.Item>{t("Manager")}</Breadcrumb.Item>
                        <Breadcrumb.Item active>{t("Add")}</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>{t("Add New Central Customer Care Manager ")}</h4>
                    {/* <p className="mb-0">{t("Use this page to add a new incharge")}</p> */}
                </div>
            </div>

            <Row className="mt-3">
                <Col>
                    <Alert variant="info">
                        <FontAwesomeIcon icon={faHome} />&nbsp;&nbsp;{t("Manager Info")}
                    </Alert>
                    <Form.Group className="mb-3 mt-4">
                        <Form.Label>{t("Manager Name")}</Form.Label>
                        <Form.Control
                            required
                            isInvalid={formErrors["managerName"]?.length}
                            type="text"
                            onChange={(event) => {
                                onFormInputChange("managerName", event.target.value);
                            }} />
                        {formErrors["managerName"]?.length && (
                            <Form.Control.Feedback type="invalid">{t("Please enter Manager name.")}</Form.Control.Feedback>
                        )}

                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control required isInvalid={formErrors["phoneNumber"]?.length} type="text" onChange={(event) => {
                            onFormInputChange("phoneNumber", event.target.value);
                        }} />
                        {formErrors["phoneNumber"]?.length && (
                            <Form.Control.Feedback type="invalid">{t("Please enter phonenumber.")}</Form.Control.Feedback>
                        )}

                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Email Id</Form.Label>
                        <Form.Control required isInvalid={formErrors["emailId"]?.length} type="email" onChange={(event) => {
                            onFormInputChange("emailId", event.target.value);
                        }} />
                        {formErrors["emailId"]?.length && (
                            <Form.Control.Feedback type="invalid">{t(formErrors["emailId"])}</Form.Control.Feedback>
                        )}

                    </Form.Group>
                </Col>
                <Col>
                    <Alert variant="info">
                        <FontAwesomeIcon icon={faUserCircle} />&nbsp;&nbsp;{t("Login Info")}
                    </Alert>
                    <Form.Group className="mb-3 mt-4">
                        <Form.Label>{t("UserName")}</Form.Label>
                        <Form.Control required isInvalid={formErrors["username"]?.length} type="text" onChange={(event) => {
                            onFormInputChange("username", event.target.value);
                        }} />
                        {formErrors["username"]?.length && (
                            <Form.Control.Feedback type="invalid">{t("Please enter a username")}</Form.Control.Feedback>
                        )}

                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("Password")}</Form.Label>
                        <Form.Control required isInvalid={formErrors["password"]?.length} type="text" onChange={(event) => {
                            onFormInputChange("password", event.target.value);
                        }} />
                        {formErrors["password"]?.length && (
                            <Form.Control.Feedback type="invalid">{t("Please enter a password")}</Form.Control.Feedback>
                        )}

                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("Repeat Password")}</Form.Label>
                        <Form.Control required isInvalid={formErrors["repeatPassword"]?.length} type="text" onChange={(event) => {
                            onFormInputChange("repeatPassword", event.target.value);
                        }} />
                        {formErrors["repeatPassword"]?.length && (
                            <Form.Control.Feedback type="invalid">{t("Please enter the same password as above")}</Form.Control.Feedback>
                        )}

                    </Form.Group>
                    <Row className="d-flex justify-content-between mt-5">
                        <Button
                            style={{ width: '98%' }}
                            className="mx-2"
                            variant="primary"
                            onClick={handleFormSubmit}
                        >{t("Create User")}</Button>
                        <Button className="mt-3" variant="outline" >{t("Cancel")}</Button>
                    </Row>
                </Col>
            </Row>

        </div>
    )
}
export default AddCustomerCareManager